export default class guideProgress {
  constructor(element) {
    this.el = element
    this.getProgress = this.getProgress.bind(this)
    this.setProgress = this.setProgress.bind(this)
    this.input = this.el.querySelector('input')
    this.circle = this.el.querySelector('circle')
    this.showNumber = this.el.querySelector('.show-number')
    this.userId = this.el.dataset.userid
    this.init()
  }

  init() {
    let radius = this.circle.r.baseVal.value;
    let circumference = radius * 2 * Math.PI;
    this.circle.style.strokeDasharray = `${circumference} ${circumference}`;
    this.circle.style.strokeDashoffset = `${circumference}`;
    this.getProgress(circumference);
  }

  getProgress(circumference) {

    fetch(`/api/guides/user-status/${this.userId}`)
      .then(response => response.json())
      .then(data => {
        if (data.hasUnfinishedGuides) {
        this.el.classList.remove('hidden');
        this.setProgress(data.unfinishedGuides[data.unfinishedGuides.length - 1].percentageDone, circumference);
        } else {
          this.el.classList.add('hidden');
        }
      })
      .catch(error => console.log('error', error));
  }

  setProgress(percent, circumference) {
    percent === 100 ? this.el.classList.add('hidden') : this.el.classList.remove('hidden');
    const offset = circumference - percent / 100 * circumference;
    this.circle.style.strokeDashoffset = offset;
    this.showNumber.innerHTML = percent + "%"
  }
}
